import { z } from "zod";
import { frazioneMerceologicaSchema, paginationSchema } from "./common.js";
export const statoKitSchema = z.enum([
    "ASSEGNATO",
    "CONSEGNATO",
    "RITIRATO",
    "SOSTITUITO",
]);
export const statoContenitoreSchema = z.enum([
    "ATTIVO",
    "SOSTITUITO",
    "SMARRITO",
    "DANNEGGIATO",
]);
export const contenitoreSchema = z.object({
    id: z.string().uuid(),
    codice_barcode: z.string().max(64),
    kit_id: z.string().uuid(),
    frazione_merceologica: frazioneMerceologicaSchema,
    volumetria_litri: z.number().int().positive(),
    stato: statoContenitoreSchema,
    data_apposizione: z.string().nullable().optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const kitSchema = z.object({
    id: z.string().uuid(),
    codice_kit: z.string().max(32),
    utenza_id: z.string().uuid(),
    stato: statoKitSchema,
    data_consegna: z.string().nullable().optional(),
    note: z.string().nullable().optional(),
    contenitori: z.array(contenitoreSchema).optional(),
    created_at: z.string().datetime(),
    updated_at: z.string().datetime(),
});
export const createKitSchema = z.object({
    codice_kit: z.string().min(1).max(32),
    utenza_id: z.string().uuid(),
    stato: statoKitSchema.default("ASSEGNATO"),
    data_consegna: z.string().nullable().optional(),
    note: z.string().nullable().optional(),
});
export const associaUtenzaSchema = z.object({
    utenza_id: z.string().uuid(),
});
export const addContenitoreSchema = z.object({
    codice_barcode: z.string().min(1).max(64),
    frazione_merceologica: frazioneMerceologicaSchema,
    volumetria_litri: z.number().int().positive(),
    data_apposizione: z.string().nullable().optional(),
});
export const sostituisciContenitoreSchema = z.object({
    nuovo_codice_barcode: z.string().min(1).max(64),
    volumetria_litri: z.number().int().positive().optional(),
    motivo: z.string().max(240).optional(),
});
export const kitFiltersSchema = paginationSchema.extend({
    stato: statoKitSchema.optional(),
    zona_id: z.string().uuid().optional(),
    frazione: frazioneMerceologicaSchema.optional(),
    utenza_id: z.string().uuid().optional(),
    q: z.string().max(200).optional(),
});
//# sourceMappingURL=kit.js.map